console.log("[sur-commande] loaded");
document.addEventListener("DOMContentLoaded", function() {
  console.log("[sur-commande] DOMContentLoaded fired");
});
(function () {
  function getEls() {
    return {
      note: document.getElementById("on-demand-note"),
      invEl: document.getElementById("VariantInventoryJSON"),
      idInput: document.querySelector('form[action*="/cart/add"] input[name="id"], input[name="id"]')
    };
  }

  function readInventoryData(invEl) {
    if (!invEl) return [];
    try {
      return JSON.parse(invEl.textContent || "[]");
    } catch (e) {
      console.warn("[sur-commande] JSON parse error", e);
      return [];
    }
  }

  function updateNote() {
    const { note, invEl, idInput } = getEls();
    if (!note || !invEl || !idInput) return;

    const inventoryData = readInventoryData(invEl);
    const variantId = idInput.value;

    const item = inventoryData.find(v => String(v.id) === String(variantId));
    if (!item) {
      note.style.display = "none";
      return;
    }

    const isOnDemand =
      item.inventory_policy === "continue" &&
      Number(item.inventory_quantity) <= 0;

    note.style.display = isOnDemand ? "block" : "none";
  }

  function initObservers() {
    const { idInput } = getEls();
    if (!idInput) return;

    // 1) Mise à jour initiale
    updateNote();

    // 2) Events classiques (si le thème les déclenche)
    idInput.addEventListener("change", updateNote);
    idInput.addEventListener("input", updateNote);

    // 3) IMPORTANT : si le thème modifie .value sans event → observer l’attribut "value"
    const obs = new MutationObserver(() => updateNote());
    obs.observe(idInput, { attributes: true, attributeFilter: ["value"] });

    // 4) Certains thèmes dispatchent un event global lors d’un changement de variante
    document.addEventListener("variant:change", updateNote);
    document.addEventListener("product:variant-change", updateNote);

    // 5) Shopify peut recharger une section (theme editor / AJAX)
    document.addEventListener("shopify:section:load", updateNote);
  }

  // Init
  document.addEventListener("DOMContentLoaded", initObservers);

  // Fallback si DOMContentLoaded déjà passé
  if (document.readyState !== "loading") {
    initObservers();
  }
})();